// extracted by mini-css-extract-plugin
module.exports = {"title":"_1410bfd27b--title--MPJn3","container":"_1410bfd27b--container--iVWfT","item":"_1410bfd27b--item--gtRZF"};